export const GET_LOGS = 'GET_LOGS';
export const GET_COUNTRIES = 'GET_COUNTRIES';
export const GET_CITIES = 'GET_CITIES';
export const GETTING_CITIES = 'GETTING_CITIES';
export const GET_STATES = 'GET_STATES';
